export const getColorClass = (value: number): string => {
  if (value < 50) {
    return 'text-red-tertiary';
  }
  if (value >= 50 && value < 70) {
    return 'text-yellow-tertiary';
  }
  return 'text-green-secondary';
};

export const getColorObject = (value: number | null): { bgColor: string; textColor: string } => {
  if (!value) return { bgColor: 'bg-white', textColor: 'text-black' };
  if (value < 50) {
    return { bgColor: 'bg-red-secondary', textColor: 'text-red-tertiary' };
  }
  if (value >= 50 && value < 70) {
    return { bgColor: 'bg-[#fef3c7]', textColor: 'text-[#92400e]' };
  }
  return { bgColor: 'bg-[#CFF7D3]', textColor: 'text-green-tertiary' };
};

export const getAttendanceColor = (value: string | number | null) => {
  if (value === '0' || value === '0.0' || value === 0) return { bg: '#FDD3D0', text: '#9E9E9E' };
  if (value === '0.5' || value === 0.5) return { bg: '#FFF9C4', text: '#92400e' };
  if (value === '1' || value === '1.0' || value === 1) return { bg: '#CFF7D3', text: '#4CAF50' };
  return { bg: '#ffffff', text: '#000000' };
};
